// src/components/common/PasswordInput.jsx
import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

const PasswordInput = ({
	value,
	onChange,
	placeholder = 'Enter your password',
	className = '',
	required = false,
	onKeyDown,
	onKeyPress,
	...props
}) => {
	const [showPassword, setShowPassword] = useState(false);

	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	};

	return (
		<div className='relative'>
			<input
				type={showPassword ? 'text' : 'password'}
				value={value}
				onChange={onChange}
				onKeyDown={onKeyDown}
				onKeyPress={onKeyPress}
				className={`w-full p-4 pr-12 bg-white/5 border border-white/10 rounded-2xl outline-none text-white relative z-[1] ${className}`}
				placeholder={placeholder}
				required={required}
				{...props}
			/>
			<button
				type='button'
				onClick={togglePasswordVisibility}
				className='absolute right-3 top-1/2 z-[2] -translate-y-1/2 text-white/60 hover:text-white/100 transition-colors focus:outline-none'
				aria-label={showPassword ? 'Hide password' : 'Show password'}
			>
				{showPassword ? (
					<EyeOff className='w-5 h-5' />
				) : (
					<Eye className='w-5 h-5' />
				)}
			</button>
		</div>
	);
};

export default PasswordInput;
